(() => {
  customElements.whenDefined('deferred-media').then(() => {
    if (customElements.get('edc-intro-video')) return;

    class ProductVideoIntro extends customElements.get('deferred-media') {
      async loadContent() {
        if (this.starting || this.hasAttribute('loaded')) return;
        this.starting = true;
        const poster = this.querySelector('.edc-product-overview__play');
        const intro = this.querySelector('.edc-video-intro');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        poster.setAttribute('aria-disabled', 'true');
        this.setAttribute('aria-busy', 'true');

        if (intro && !reducedMotion && typeof intro.animate === 'function') {
          intro.hidden = false;
          const icon = poster.querySelector('svg');
          const label = poster.querySelector('span');
          const posterBounds = poster.getBoundingClientRect();
          const iconBounds = icon.getBoundingClientRect();
          const centerX = posterBounds.left + posterBounds.width / 2 - iconBounds.left - iconBounds.width / 2;
          const centerY = posterBounds.top + posterBounds.height / 2 - iconBounds.top - iconBounds.height / 2;
          const centered = `translate(${centerX}px, ${centerY}px)`;
          const logoStart = 720;
          const animate = (element, frames, options) => element.animate(frames, { fill: 'both', ...options });
          this.introAnimations = [
            animate(label, [{ opacity: 1 }, { opacity: 0 }], { duration: 180, easing: 'ease-out' }),
            animate(icon, [
              { transform: 'translate(0, 0) rotate(0deg) scale(1)', opacity: 1, offset: 0, easing: 'cubic-bezier(.22, 1, .36, 1)' },
              { transform: `${centered} rotate(0deg) scale(1)`, opacity: 1, offset: 300 / logoStart, easing: 'cubic-bezier(.4, 0, .2, 1)' },
              { transform: `${centered} rotate(360deg) scale(.15)`, opacity: 0, offset: 1 },
            ], { duration: logoStart }),
            animate(poster, [{ opacity: 1 }, { opacity: 0 }], { delay: logoStart, duration: 1 }),
            animate(intro, [{ visibility: 'hidden' }, { visibility: 'visible' }], { delay: logoStart, duration: 1 }),
            animate(intro.querySelector('.edc-video-intro__outline'),
              [{ clipPath: 'inset(0 100% 0 0)', opacity: 0.6 }, { clipPath: 'inset(0 0% 0 0)', opacity: 1 }],
              { delay: logoStart + 160, duration: 750, easing: 'ease-out' }),
            animate(intro.querySelector('.edc-video-intro__stroke'),
              [{ strokeDashoffset: 1 }, { strokeDashoffset: 0 }],
              { delay: logoStart + 380, duration: 900, easing: 'linear' }),
            animate(intro.querySelector('.edc-video-intro__finish'), [{ opacity: 0 }, { opacity: 1 }],
              { delay: logoStart + 1180, duration: 220 }),
            animate(intro, [{ opacity: 1 }, { opacity: 0 }], { delay: logoStart + 1650, duration: 200 }),
          ];
          try {
            await Promise.all(this.introAnimations.map((animation) => animation.finished));
          } catch {
            return;
          }
        }

        if (!this.isConnected) return;
        if (intro) intro.hidden = true;
        super.loadContent(false);
        this.querySelector('iframe')?.focus({ preventScroll: true });
        this.removeAttribute('aria-busy');
        this.introAnimations?.forEach((animation) => animation.cancel());
        this.introAnimations = null;
        this.starting = false;
      }

      disconnectedCallback() {
        this.introAnimations?.forEach((animation) => animation.cancel());
        this.introAnimations = null;
        this.starting = false;
        this.removeAttribute('aria-busy');
        this.querySelector('.edc-product-overview__play')?.removeAttribute('aria-disabled');
        const intro = this.querySelector('.edc-video-intro');
        if (intro) intro.hidden = true;
      }
    }

    customElements.define('edc-intro-video', ProductVideoIntro);
  });
})();
